import { RETURN_STAGE, RETURN_STEP_KEYS } from "../constants";
import type { Claim, ClaimTranslator, StepperStep } from "../types";
import type { ReturnStage } from "./returnState";
import { getActiveReturnLabel, getReturnStage } from "./returnState";

const getReturnStepState = (
  stepIndex: number,
  stage: ReturnStage,
): StepperStep["state"] => {
  if (stage === RETURN_STAGE.RESOLVED) {
    return "completed";
  }
  const stageIndex = RETURN_STEP_KEYS.findIndex((key) => key === stage);
  if (stepIndex < stageIndex) {
    return "completed";
  }
  return stepIndex === stageIndex ? "current" : "inactive";
};

const getReturnStepDate = (
  stepKey: string,
  claim: Claim,
  timelineMap: Record<string, string>,
): string | null => {
  if (stepKey === RETURN_STAGE.REQUESTED) {
    return timelineMap.claim_filed ?? null;
  }
  if (stepKey === RETURN_STAGE.RECEIVED) {
    return getActiveReturnLabel(claim)?.delivered_at ?? null;
  }
  return null;
};

export const getReturnStepperSteps = (
  claim: Claim,
  timelineMap: Record<string, string>,
  t: ClaimTranslator,
): StepperStep[] => {
  const stage = getReturnStage(claim);
  return RETURN_STEP_KEYS.map((stepKey, index) => ({
    key: stepKey,
    label: t(`status.returns.stepper.${stepKey}`),
    date: getReturnStepDate(stepKey, claim, timelineMap),
    state: getReturnStepState(index, stage),
    subtextKey: null,
  }));
};
